import $ from 'jquery';
import EventsAndNewsView from '../views/EventsAndNewsView';
import EventsAndNews from '../models/EventsAndNews';

function start(context) {
  var params = EventsAndNews.init(context);
  EventsAndNewsView.render(params);
  bindEvents(params);
}
function refresh(back){
  var params = EventsAndNews.getNewsdata();
  if(!back){
    EventsAndNews.saveState();
  }
  EventsAndNewsView.render(params);
  bindEvents(params);
}
function bindEvents(params){

  $('.news__container').scrollTop(params.currentposition);

  $( '.news__container' ).scroll(function() {
    var scrollPosition = $(this).scrollTop();
    EventsAndNews.setPosition(scrollPosition);
  });

  $('#backbutton').on('click', async function(){
    if(await EventsAndNews.goBack()){
      refresh('back');
    }
  });
  $('.showby').on('mouseup touchend', function(){
    EventsAndNews.updateState();
    EventsAndNews.toggleShowByKeyword();
    refresh();
  });
  $('.news .item').on('mouseup touchend', function(){
    EventsAndNews.updateState();
    EventsAndNews.showFullContent(this.id);
    refresh();
  });
  $('.image-gallery .thumb').on('mouseup touchend', function(){
    var url = this.id;
    $('.image-gallery .image').attr('src', url);
    $('.image-gallery .bg').attr('style', `background-image:url(${url});`);
    $('.image-gallery .thumb').removeClass('active');
    $(this).addClass('active');
  });
  $('.keywords .list__item').on('mouseup touchend', function(){
    EventsAndNews.setKeyword(this.id);
    refresh();
  });
}

export default {
  start,
  refresh,
  bindEvents
};
